import React from "react";

function importAll(r) {
  let images = {};
  r.keys().forEach((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}
const images = importAll(
  require.context(
    "../assets/materials/christmas",
    false,
    /\.(JPG|png|jpe?g|svg)$/
  )
);

const imagesNames = [];

for (const key in images) {
  if (Object.hasOwnProperty.call(images, key)) {
    imagesNames.push(images[key].default);
  }
}

const mat1 = `W czasie trwania projektu, uczniowie i nauczyciele ze wszystkich szkół realizowali jego założenia w ramach zaplanowanych projektów cząstkowych (działania lokalne) oraz podczas spotkań międzynarodowych. Stworzono prezentacje małych Ojczyzn, które następnie zostały przekazane partnerom i społecznościom lokalnym w formie broszur. Przygotowany słowniczek stał się bazą do stworzenia gry miejskiej, która była zaplanowana jako efekt finalny projektu. Uczniowie ze wszystkich szkół nagrali wspólnie również film „Proud to be European”, który był planowanym wspólnym produktem.
Poza tym stworzyliśmy również inne, wcześniej niezaplanowane rezultaty naszego projektu. Zaliczają się do nich: konspekty lekcyjne z zakresu edukacji wczesnoszkolnej uwzględniające włączanie elementów języka angielskiego do nauczania. Powstały również gry: „Poszukiwanie skarbu w Zagrzebiu” i „Przełamanie lodów” oraz broszura z przepisami kulinarnymi. 
Podczas całego projektu przygotowywano w szkołach wystawy dokumentujące realizację założeń projektowych, prezentujące wypracowane rezultaty i promujące projekt. Rezultaty prezentowano również władzom i społecznościom lokalnym podczas europejskich pikników rodzinnych.`;

const MaterialsContext = React.createContext({
  text: mat1,
  photos: imagesNames,
});

export default MaterialsContext;
